import React from 'react';

const TypingIndicator: React.FC = () => {
  return (
    <div className="app-message-wrapper app-message-assistant">
      <div className="app-typing-indicator">
        <div className="app-typing-dot" />
        <div className="app-typing-dot" />
        <div className="app-typing-dot" />
      </div>
    </div>
  );
};

export default TypingIndicator;